import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import Images from "../../../pages/product/images";
import ProductPageWrapper from "../../../pages/product/bodyWrapper";
import Services from "../../../pages/product/services";
import Stick from "../../../pages/product/stick";
import { getProductsPhotos } from "../../../../utils";
import LandingBottom from "../bottom";
import LandingOffer from "../offer";
import LandingsOfferMobile from "../offerMobile";

export default function LandingsProductBody() {
  const { product } = useSelector((state) => state.product);
  const { cityName } = useSelector((state) => state.location);

  const photos = getProductsPhotos(product);

  return (
    <ProductPageWrapper
      customClass={styles.Landing}
      head={
        <div className={styles.Head}>
          <div>{product.NAME}</div>
          <span>Арт. {product.ARTICLE?.VALUE}</span>
        </div>
      }
      left={
        <>
          <div className={styles.Left}>
            <Stick />
            <Images
              images={photos}
              video={product.VIDEO}
              alt={`${product.NAME} ${product.ARTICLE?.VALUE} в ${cityName}`}
            />
            <div className={styles.Services}>
              <Services
                sectionId={product.IBLOCK_SECTION_ID}
                marka={product.MARKA?.CODE_ALT}
                isLanding={true}
              />
            </div>
          </div>
        </>
      }
      bottom={
        <>
          <LandingBottom />
          <LandingsOfferMobile />
        </>
      }
    >
      <div className={styles.MainInfo}>
        <LandingOffer />
        <div className={styles.Services}>
          <Services
            sectionId={product.IBLOCK_SECTION_ID}
            marka={product.MARKA?.CODE_ALT}
            isLanding={true}
          />
        </div>
      </div>
    </ProductPageWrapper>
  );
}
